import {Component, OnInit} from '@angular/core';
import {FullPageLoader, LoaderState} from './full-page-loader';

@Component({
    selector: 'app-full-page-loader',
    templateUrl: './full-page-loader.html',
    styleUrls: ['./full-page-loader.css']
})
export class FullPageLoaderComponent implements OnInit {
    public shouldShowLoader: boolean;

    ngOnInit(): void {
        FullPageLoader.subscribeToLoaderInstructions((value: LoaderState) => this.onLoaderStateChange(value));
    }

    private onLoaderStateChange(loaderState: LoaderState): void {
        this.shouldShowLoader = loaderState === LoaderState.Shown;
    }
}